<template>
  <div>
    <LoadingComponent v-show="pageLoading"></LoadingComponent>
    <div class="body">
      <div class="image"><img :src="activityData.image" alt=""></div>
      <div class="main">
        <div class="btn" v-if="activityData.format && activityData.format.length">
          <img :src="activityData.personBtnImage" alt="个人赛" v-if="activityData.format.includes('person') && activityData.personBtnImage" @click="handleStart(1)">
          <img :src="activityData.teamBtnImage" alt="团体赛" v-if="activityData.format.includes('team') && activityData.teamBtnImage" @click="handleStart(2)">
          <img :src="activityData.pkBtnImage" alt="PK赛" v-if="activityData.format.includes('pk') && activityData.pkBtnImage" @click="handleStart(3)">
        </div>
        <div class="action" v-if="activityData.actionShow && activityData.actionShow.length">
          <div class="item" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="activityData.actionShow.includes('rank')" @click="handleRank">排行榜</div>
          <div class="item" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="activityData.actionShow.includes('rule')" @click="isShowRule = true">活动规则</div>
          <div class="item" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" v-if="activityData.actionShow.includes('record') && activityData.lotteryRecordLink" @click="handleLottery">中奖记录</div>
        </div>
      </div>
    </div>
    <div class="rule" v-show="isShowRule" @click="isShowRule = false">
      <div :style="`background: ${ activityData.themeColor || '#FF8235' };`" class="back" @click="isShowRule = false">返回</div>
      <div class="content" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' }; background-image: url(${ activityData.ruleImage }); background-size: 100% 100%;`">
        <h2>活动规则</h2>
        <div class="desc" v-html="activityData.desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import COVER from "@/utils/COVER";
import COVERAPP from "@/utils/COVERAPP";
import { mapState, mapActions, mapMutations } from "vuex";
import LoadingComponent from '@/components/Loading';

let aid = '';
export default {
  name: 'home',
  data() {
    return {
      isShowRule: false,
      pageLoading: false,
    };
  },
  props: ["activityData"],
  computed: {
    ...mapState(["dialogData", "userinfo"]),
  },
  components: {
    LoadingComponent,
  },
  created() {
    aid = this.$route.query.id || "";
  },
  mounted() {
    COVER.yunTrack(aid, "load");
  },
  methods: {
    ...mapActions(["setUserinfo"]),
    ...mapMutations(["setToastData", "setOpenDownLoadFlag"]),
    handleStudy() {
      if (this.activityData.studyLink) {
        window.location.href = this.activityData.studyLink;
      }
    },
    async handleStart(match) {
      const _this = this;
      // 如果后台没有配置团队，则不跳转
      if (match == 2 && (!this.activityData.areaInstitution || !this.activityData.areaInstitution.length)) {
        this.setToastData({
          text: "尚未准备团体~",
        });
        return;
      }

      if (!this.userinfo || !this.userinfo.token) {
        if (!COVERAPP.Attribute.isApp() && !COVERAPP.Attribute.isWeixin() && !COVERAPP.Attribute.isTFUnion()) {
          this.setOpenDownLoadFlag(true);
          return;
        }
        
        COVER.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          if (userinfo && userinfo.token) {
            _this.setUserinfo(userinfo);
            _this.queryAnswer(match);
            return;
          }

          this.setToastData({
            text: "请先登录~",
          });
        });
        return;
      }

      this.queryAnswer(match);
    },
    // 去团队赛
    goTeamPK() {
      const _this = this;
      const activityData = this.activityData;
      if (!this.userinfo || !this.userinfo.token) {
        if (!COVERAPP.Attribute.isApp() && !COVERAPP.Attribute.isWeixin()) {
          this.setOpenDownLoadFlag(true);
          return;
        }
        
        COVER.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          if (userinfo && userinfo.token && userinfo.device_id) {
            _this.setUserinfo(userinfo);
            return;
          }

          this.setToastData({
            text: "请先登录~",
          });
        });
        return;
      }

      if (!activityData.areaInstitution || !activityData.areaInstitution.length) {
        this.setToastData({
          text: "未可用团队可供选择~",
        });
        return;
      }

      this.queryAnswer(true);
    },
    handleRank() {
      this.$router.push('rank?id=' + aid);
    },
    handleLottery() {
      const _this = this;
      if (!this.userinfo || !this.userinfo.token) {
        COVER.getUser((res) => {
          const userinfo = JSON.parse(JSON.stringify(res));
          if (userinfo && userinfo.token) {
            _this.setUserinfo(userinfo);
            window.location.href = this.activityData.lotteryRecordLink;
            return;
          }

          this.setToastData({
            text: "请先登录~",
          });
        });

        return;
      }

      window.location.href = this.activityData.lotteryRecordLink;
    },
    async queryAnswer(match) {
      const activityData = this.activityData;
      let loadtime = setTimeout(() => {
        this.pageLoading = true;
      }, 1500);
      const res = await COVER.$post("/answer/user/count", {
        aid,
        match,
        userinfo: this.userinfo,
      }).catch(err => {
        this.setToastData({
          text: "网络错误~",
        });
      });
      this.pageLoading = false;
      clearTimeout(loadtime);

      if (res.errno === 0) {
        const status = res.data.status;
        if (status === 0) {
          // 判断是否开启需要填写信息
          let isOpenInput = false;
          switch (match) {
            case 1:
              isOpenInput = activityData.answerPerson.isOpenName || activityData.answerPerson.isOpenPhone || false;
              break;
            case 2:
              isOpenInput = true;
              break;
            case 3:
              isOpenInput = activityData.answerPk.isOpenName || activityData.answerPk.isOpenPhone || false;
              break;
          }

          if (isOpenInput) {
            this.$router.push('select?id=' + aid + '&match=' + match);
            return;
          }

          this.$router.push('answer?id=' + aid + '&match=' + match);
          return;
        }

        let statusText = {
          '2010': '答题未开始',
          '2011': '答题已结束',
          '2012': '已超过答题总数',
          '2013': '当日已答题',
          '2014': '已完成答题',
          '2015': '当日已完成团队赛答题'
        }
        this.setToastData({
          text: statusText[status] ||  "网络错误~",
        });
        return;
      }

      this.setToastData({
        text: res.errmsg,
      });
    },
    toRgba(c) {
      if (!c) {
        return;
      }
      return `linear-gradient(45deg, ${ COVER.hexToRgba(c, 0.7) }, ${ COVER.hexToRgba(c) })`;
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  .image {
    min-height: 60vw;
    img {
      width: 100%;
    }
  }
  .main {
    padding: 4vw 7.4vw;
    box-sizing: border-box;
    .btn {
      display: flex;
      width: 100%;
      flex-direction: column;
      img {
        width: 100%;
        margin-bottom: 3vw;
      }
    }
    .action {
      font-size: 3.8vw;
      display: flex;
      justify-content: space-between;
      text-align: center;
      margin-top: 5vw;
      .item {
        width: 100%;
        padding: 2.5vw 0;
        border-radius: 1vw;
        box-shadow: 0 .8vw 0 rgba(0, 0, 0, .1);
        &:first-child {
          margin-right: 3vw;
        }
        &:last-child {
          margin-left: 3vw;
        }
      }
    }
  }
}
/* .head-btn {
  display: flex;
  justify-content: space-between;
  img {
    width: 48%;
  }
}
.btnimg {
  width: 48%;
  &:last-child {
    margin-left: 3vw;
  }
} */
.rule {
  position: fixed;
  z-index: 2;
  background: rgba(#000, .7);
  padding: 0 8.3vw;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .content {
    width: 100%;
    height: 75.5vh;
    font-size: 3.2vw;
    color: white;
    border-radius: 2vw;
    animation: anrule .3s 0s ease forwards;
    h2 {
      text-align: center;
      padding: 6vw 0;
      font-size: 5.8vw;
    }
    .desc {
      padding: 0 4vw;
      box-sizing: border-box;
      line-height: 1.6em;
      max-height: 62vh;
      overflow: scroll;
    }
  }
  .back {
    position: fixed;
    top: 7vw;
    left: 5vw;
    color: white;
    font-size: 4.4vw;
    border-radius: 2vw;
    padding: 2vw 3vw;
  }
}
@keyframes anrule {
  0% {
    transform: scale(.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>